export default "__VITE_ASSET__Xu1DZJWZ__"